
    <div class="wp-overlay">
      <div class="wp-center">
        <video #wpVideoPlayer width="600" controls autoplay (loadmedtadata)="getSize()">
          <source [src]="url" [type]="file.mime">
        </video>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/file.view.video.ts.FileViewVideoNativeComponent.html